export enum BannerTypeIconEnum {
  Info = 'info',
  Warn = 'warning',
  Critical = 'dangerous'
}
